module.exports = __webpack_public_path__ + "img/Slice8.b38eccc0.png";